import React from "react";
import I18nServicePage from "@/components/I18nServicePage";
import FlowProgramCard from "@/components/FlowProgramCard";
import { IMG } from "@/lib/config";

export default function ManagementLeadership() {
  return (
    <I18nServicePage
      i18nKey="management"
      image={IMG.management}
      testIdPrefix="mgmt"
      accentClass="text-accent-orange"
      afterSections={<FlowProgramCard />}
    />
  );
}
